<script setup lang="ts">

const props = defineProps({
  list: Array,
  key_field: String,
  title_field: Array,
  placeholder: String,
  multiple: Boolean,
  showSelectedTitle: {
    type: Boolean,
    default: true
  },
  selected: {
    type: Object,
    default: null
  },
  hasCreate: {
    type: Boolean,
    default: false
  },
  hasEdit: {
    type: Boolean,
    default: false
  },
  hasDelete: {
    type: Boolean,
    default: false
  },
  create_text: {
    type: String || null,
    default: () => {
      const {t} = useI18n()
      return t('input_forms.button.add_new')
    }
  },
})
const emit = defineEmits(['select', 'delete', 'edit','create'])

const openDropdown = ref(false)

function handleSelect(item: object) {
  emit('select', item)
  if (!props.multiple) {
    openDropdown.value = false
  }
}

function handleDelete(item: object) {
  emit('delete', item)
}

function handleEdit(item: object) {
  emit('edit', item)
}
function handleCreate() {
  emit('create')
}
</script>

<template>
  <div >
    <div  type="button" @click="openDropdown = !openDropdown"
            class="input-decorator cursor-pointer text-left w-full bg-secondary relative px-3 py-1 z-[5]">
      <div class="p-1.5 flex justify-between items-center pr-2.5">
        <div class="overflow-x-scroll no-scrollbar flex flex-row gap-2 md:max-w-[480px] max-w-44" v-if="selected && showSelectedTitle">
           <template v-for="field in title_field">
            <span v-if="selected[field]" class="font-bold  text-green-600">{{ selected[field] }} {{}}</span>
          </template>
        </div>
        <span v-else>{{ placeholder }}</span>
        <IconUIChevronUp class="transition-all cursor-pointer duration-150 ease-in" :class="{ 'flip': !openDropdown }"/>
      </div>
      <div :class="{ 'h-0' : !openDropdown, 'h-fit border' : openDropdown }"
           class=" transition-all duration-100 ease-in absolute left-0 top-[50px] bg-white max-h-[200px] overflow-y-scroll z-10 border-light rounded-md max-w-full w-full">
        <div v-for="item in list" :key="item[key_field]"
             class="p-2 border-b border-light overflow-hidden overflow-ellipsis flex gap-2 items-center">
          <span class="overflow-x-scroll no-scrollbar" @click.stop.prevent="handleSelect(item)">
            <span class="flex flex-row gap-2 md:max-w-[480px] max-w-44"  >
                <template  v-for="field in title_field">
              <span v-if="item[field]"
                    :class="selected && selected[key_field]===item[key_field]  ? 'font-bold text-green-600' : '' ">{{
                  item[field]
                }} {{}}</span>
            </template>
            </span>

          </span>
          <div v-if="item?.show_controls !== false" class="flex gap-2 ">
            <UIBtn
                v-if="hasEdit"
                :border="'gray'"
                :color="'green'"
                class="py-1  px-2 "
                @click="handleEdit(item)"
            >
              <IconUIEdit/>
            </UIBtn>
            <UIBtn
                v-if="hasDelete"
                :color="'red'"
                class="py-1 px-2 rounded-xl "
                @click="handleDelete(item)"
            >
              <IconUIBin class="h-6 w-4 fill-white"/>
            </UIBtn>
          </div>
        </div>
        <div
            v-if="hasCreate"
            class="p-2 cursor-pointer"
            @click="handleCreate"
        >
          {{ create_text }}
        </div>
      </div>
    </div>
    <div v-if="openDropdown" @click="openDropdown = false" class="fixed top-0 left-0 w-full h-full z-[3]"></div>
  </div>
</template>

<style scoped>

</style>